import React from 'react';

import cx from 'classnames';

import styles from './TableCell.module.scss';

export interface TableCellProps extends React.HTMLProps<HTMLTableCellElement> {
  /** Child of `Table.Cell` which should be any element. */
  children: React.ReactNode;
  /** Dictate how many columns the cell will span. */
  colSpan?: number;
  /** Alignment for content in table cell.. */
  align?: 'start' | 'center' | 'end';
  /** Change the font within the cell. 🚧 This will be removed when Text component gets released.🚧*/
  font?: 'sans' | 'monospace';
  /** Add a CSS class to adjust cell content.*/
  cellWrapperClassName?: Parameters<typeof cx>[0];
}

export const TableCell: React.FC<TableCellProps> = ({
  children,
  colSpan,
  align = 'start',
  font = 'sans',
  className,
  cellWrapperClassName,
  ...rest
}) => (
  <td
    {...rest}
    className={cx(
      styles.cell,
      align && styles[align],
      font && styles[font],
      className,
    )}
    colSpan={colSpan}
  >
    <span className={cx(styles.cellWrapper, cellWrapperClassName)}>
      {children}
    </span>
  </td>
);

export default TableCell;
export { styles };
